import React, { useEffect, useState } from "react";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation, NavLink, useNavigate } from "react-router-dom";
import * as apiUrl from "../../apiUrl";

function Header() {
  const [headerMenu, setHeaderMenu] = useState([]);
  const [headerLogo, setHeaderLogo] = useState(null);
  const [navClassName, setNavClassName] = useState("");
  const [navbarExpanded, setNavbarExpanded] = useState(false);
  const [hoveredDropdown, setHoveredDropdown] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHeaderMenu = async () => {
      try {
        const response = await fetch(apiUrl.apiUrl + `/api/header/menu`);
        if (!response.ok) throw new Error("Failed to fetch menu data");
        const data = await response.json();
        setHeaderMenu(data);
      } catch (error) {
        console.error("Error fetching menu data:", error);
      }
    };

    const fetchLogos = async () => {
      try {
        const logoresponse = await fetch(apiUrl.apiUrl + `/api/logos/section`);
        if (!logoresponse.ok) throw new Error("Failed to fetch logo data");
        const logodata = await logoresponse.json();

        const logoPathMap = {
          "": "",
          // "/properties/marquis-horizon": "Marquis Horizon",
          // "/properties/marquis-one": "Marquis One",
          // "/properties/marquis-vista": "Marquis Vista",
          // "/properties/marquis-insignia": "Marquis Insignia",
          // "/properties/marquis-elegance": "Marquis Elegance",
          // "/properties/marquis-galleria": "Marquis Galleria",
          // "/properties/marquis-signature": "Marquis Signature",
          // "/properties/2020-marquis": "2020 Marquis",
        };
        const pageTitle = logoPathMap[location.pathname] || "Header Logo";
        const selectedLogo = logodata.find(
          (logo) => logo.logo_title === pageTitle,
        );
        setHeaderLogo(selectedLogo);
      } catch (error) {
        console.error("Error fetching logo data:", error);
      }
    };

    const handleScroll = () => {
      setNavClassName("navactive");
    };

    fetchHeaderMenu();
    fetchLogos();
    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  const handleLinkClick = (slug) => {
    const [basePath, section] = slug.split("#");
    if (section) {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
      }
    }
    setNavbarExpanded(false);
    setHoveredDropdown(null);
  };

  const handleDropdownClick = (slug) => {
    navigate(slug);
    setNavbarExpanded(false);
    setHoveredDropdown(null);
  };

  return (
    <Navbar
      fixed="top"
      bg="light"
      expand="lg"
      className={`marquis-navbar ${navClassName}`}
      expanded={navbarExpanded}
      onToggle={() => setNavbarExpanded(!navbarExpanded)}
    >
      <Container fluid className="marquis-navBG">
        <Navbar.Brand>
          <Link to="/">
            {headerLogo && (
              <img
                src={apiUrl.apiUrl + `/${headerLogo.logo}`}
                className="img-fluid bgLogo"
                alt={headerLogo.logo_title}
              />
            )}
          </Link>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
          {headerMenu.map((menu) =>
            menu.children && menu.children.length > 0 ? (
              <NavDropdown
                title={
                  <span
                    onClick={() => {
                      if (window.innerWidth >= 992) {
                        navigate(menu.slug);
                        setNavbarExpanded(false);
                        setHoveredDropdown(null);
                      }
                    }}
                  >
                    {menu.menu_text}
                  </span>
                }
                key={menu.id}
                id={`${menu.menu_text
                  .toLowerCase()
                  .replace(/\s+/g, "-")}-dropdown`}
                show={hoveredDropdown === menu.id}
                onMouseEnter={() => {
                  if (window.innerWidth >= 992) {
                    setHoveredDropdown(menu.id);
                  }
                }}
                onMouseLeave={() => {
                  if (window.innerWidth >= 992) {
                    setHoveredDropdown(null);
                  }
                }}
                onClick={() => {
                  if (window.innerWidth < 992) {
                    setHoveredDropdown((prev) =>
                      prev === menu.id ? null : menu.id,
                    );
                  }
                }}
              >
                {menu.children.map((child) => (
                  <NavDropdown.Item key={child.id}>
                    <NavLink
                      to={child.slug}
                      className="nav-link"
                      onClick={() => handleDropdownClick(child.slug)}
                    >
                      {child.menu_text}
                    </NavLink>
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            ) : (
              <Nav.Item key={menu.id}>
                <NavLink
                  to={menu.slug}
                  className="nav-link"
                  onClick={() => handleLinkClick(menu.slug)}
                >
                  {menu.menu_text}
                </NavLink>
              </Nav.Item>
            ),
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
